// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 延期券签字 POST /sign/delay_coupon */
export async function signDelayCouponUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.signDelayCouponUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultESignDelayCouponStartResp>('/sign/delay_coupon', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 延期券生成签字pdf POST /sign/delay_coupon/generateSignPdf */
export async function signDelayCouponGenerateSignPdfUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.signDelayCouponGenerateSignPdfUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/sign/delay_coupon/generateSignPdf', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 延期券生成签字pdf（智能验证码版） POST /sign/delay_coupon/generateSignPdf/v2 */
export async function signDelayCouponGenerateSignPdfV2UsingPOST(
  body: API.DelayCouponContractV2Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/sign/delay_coupon/generateSignPdf/v2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取脱敏合同预览件地址 GET /sign/delay_coupon/oss-url */
export async function signDelayCouponOssUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.signDelayCouponOssUrlUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/sign/delay_coupon/oss-url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取签字url POST /sign/delay_coupon/signUrl */
export async function signDelayCouponSignUrlUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.signDelayCouponSignUrlUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/sign/delay_coupon/signUrl', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取签字url（智能验证码版） POST /sign/delay_coupon/signUrl/v2 */
export async function signDelayCouponSignUrlV2UsingPOST(
  body: API.DelayCouponContractV2Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/sign/delay_coupon/signUrl/v2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
